var exports = {
  "p": "AutocompleteChannel.module__channelIcon___cm9JSW",
};

module.exports = exports;
